import { Injectable } from '@angular/core'
import { MbProductAdapter } from './mb-product.adapter'
import { ScopedProductData } from '@spartacus/core'

@Injectable({
  providedIn: 'root',
})
export class MbProductConnector {

  constructor (protected adapter: MbProductAdapter) {
  }

  get (urlEncodedName: string, scope = '') {
    return this.adapter.load(urlEncodedName, scope)
  }

  getMany (products: ScopedProductData[]) {
    if (!this.adapter.loadMany) {
      return products.map(product => ({
        ...product,
        data$: this.adapter.load(product.urlEncodedName, product.scope),
      }))
    }
    return this.adapter.loadMany(products)
  }

  getDetailByCode (productCode: string) {
    return this.adapter.loadProductOnProductCode(productCode)
  }
}
